export enum RodStatusEnum {
    Requested = 'Requested',
    InProgress = 'In Progress',
    InReview = 'In Review',
    Uploading = 'Uploading',
    Completed = 'Completed'
}
